// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReadMoreNonFictionalComponent_container__n7GUh {
    max-width: 95%;
    margin: 0 auto;
    padding: 0px;
    background: #1a1a1a;
    min-height: 100vh;
    color: #e0e0e0;
    padding-top: 5rem;
  }
  
  .ReadMoreNonFictionalComponent_header__5dyuj {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    position: relative;
    flex-wrap: wrap;
    gap: 15px;
  }
  
  .ReadMoreNonFictionalComponent_header__5dyuj:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 100%;
    height: 1px;
    background: #333;
  }
  
  .ReadMoreNonFictionalComponent_header__5dyuj h1 {
    font-size: 24px;
    font-weight: 600;
    color: #e0e0e0;
    margin: 0;
  }
  
  .ReadMoreNonFictionalComponent_backButton__7fikB {
    background: #e51e1e;
    border: none;
    border-radius: 20px;
    padding: 8px 16px;
    cursor: pointer;
    font-size: 14px;
    color: white;
    font-weight: 500;
  }
  
  .ReadMoreNonFictionalComponent_backButton__7fikB:hover {
    background: #e51e1e;
  }
  
  .ReadMoreNonFictionalComponent_audioGrid__mzoBE {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 20px;
    margin-top: 20px;
  }
  
  .ReadMoreNonFictionalComponent_audioCard__5NHld {
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    transition: transform 0.3s ease;
    cursor: pointer;
    background: #1e1e1e;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  
 
  
  .ReadMoreNonFictionalComponent_audioImageContainer__rtJe1 {
    overflow: hidden;
    position: relative;
    height: auto;
  }
  
  .ReadMoreNonFictionalComponent_audioImage__xfFr2 {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }
  
  .ReadMoreNonFictionalComponent_audioCard__5NHld:hover .ReadMoreNonFictionalComponent_audioImage__xfFr2 {
    transform: scale(1.05);
  }
  
  .ReadMoreNonFictionalComponent_categoryBadge__I93yI {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(229, 80, 30, 0.8);
    color: white;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 500;
    z-index: 1;
  }
  
  .ReadMoreNonFictionalComponent_loadingContainer__3Qeho, .ReadMoreNonFictionalComponent_errorContainer__N\\+QeX {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50vh;
  }
  
  .ReadMoreNonFictionalComponent_error__98-7G {
    color: #ef5350;
    background: #2c2c2c;
    padding: 15px 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    font-size: 15px;
    text-align: center;
  }
  
  .ReadMoreNonFictionalComponent_noContent__FTgZV {
    text-align: center;
    padding: 40px 20px;
    color: #9e9e9e;
    font-size: 16px;
    background: #1e1e1e;
    border-radius: 8px;
    margin-top: 20px;
  }
  
  .ReadMoreNonFictionalComponent_searchContainer__9Kww5 {
    position: relative;
    margin-left: auto;
    width: 240px;
  }
  
  .ReadMoreNonFictionalComponent_searchInput__wXk65 {
    padding: 8px 15px 8px 36px;
    border-radius: 20px;
    border: 1px solid #333;
    font-size: 14px;
    background: #1e1e1e;
    color: #e0e0e0;
  }
  
  .ReadMoreNonFictionalComponent_searchInput__wXk65:focus {
    outline: none;
    border-color: #e51e1e;
  }
  
  .ReadMoreNonFictionalComponent_searchInput__wXk65::placeholder {
    color: #9e9e9e;
  }
  
  .ReadMoreNonFictionalComponent_searchIcon__7uk9A {
    position: absolute;
    top: 50%;
    left: 12px;
    transform: translateY(-50%);
    color: #9e9e9e;
  }
  
  /* Skeleton loading animation */
  .ReadMoreNonFictionalComponent_skeletonCard__sYBuQ {
    border-radius: 8px;
    overflow: hidden;
    background: #1e1e1e;
  }
  
  .ReadMoreNonFictionalComponent_skeletonImage__FT-YP {
    height: 200px;
    background: #2a2a2a;
    animation: ReadMoreNonFictionalComponent_pulse__skfHe 1.5s infinite alternate;
  }
  
  .ReadMoreNonFictionalComponent_skeletonContent__PWENg {
    padding: 15px;
  }
  
  .ReadMoreNonFictionalComponent_skeletonTitle__CUbzP {
    height: 16px;
    width: 90%;
    background: #2a2a2a;
    border-radius: 4px;
    margin-bottom: 8px;
    animation: ReadMoreNonFictionalComponent_pulse__skfHe 1.5s infinite alternate;
  }
  
  .ReadMoreNonFictionalComponent_skeletonAuthor__UJwfI {
    height: 12px;
    width: 60%;
    background: #2a2a2a;
    border-radius: 4px;
    animation: ReadMoreNonFictionalComponent_pulse__skfHe 1.5s infinite alternate;
  }
  
  @keyframes ReadMoreNonFictionalComponent_pulse__skfHe {
    from { opacity: 0.6; }
    to { opacity: 0.9; }
  }
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .ReadMoreNonFictionalComponent_header__5dyuj {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }
    
    .ReadMoreNonFictionalComponent_searchContainer__9Kww5 {
      width: 100%;
      margin-left: 0;
    }
    
    .ReadMoreNonFictionalComponent_audioGrid__mzoBE {
      grid-template-columns: repeat(4, 1fr);
      gap: 15px;
    }
    
    .ReadMoreNonFictionalComponent_audioImageContainer__rtJe1 {
      height: 200px;
    }
  }
  @media (max-width: 480px) {
    .ReadMoreNonFictionalComponent_header__5dyuj h1 {
      font-size: 18px;
    }
    
    .ReadMoreNonFictionalComponent_backButton__7fikB {
      padding: 6px 12px;
      font-size: 12px;
    }
    
    .ReadMoreNonFictionalComponent_audioGrid__mzoBE {
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
    }
    
    .ReadMoreNonFictionalComponent_audioImageContainer__rtJe1 {
      height: 180px;
    }
    
    .ReadMoreNonFictionalComponent_searchInput__wXk65 {
      width: 50%;
    }
  }`, "",{"version":3,"sources":["webpack://./src/ShortStories/Component/CSS/ReadMoreNonFictionalComponent.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,WAAW;IACX,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;IACxC,+BAA+B;IAC/B,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,sBAAsB;EACxB;;;;EAIA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,kCAAkC;IAClC,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,cAAc;EAChB;;EAEA,+BAA+B;EAC/B;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,6EAAwC;EAC1C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,6EAAwC;EAC1C;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,6EAAwC;EAC1C;;EAEA;IACE,OAAO,YAAY,EAAE;IACrB,KAAK,YAAY,EAAE;EACrB;;EAEA,2BAA2B;EAC3B;IACE;MACE,sBAAsB;MACtB,uBAAuB;MACvB,SAAS;IACX;;IAEA;MACE,WAAW;MACX,cAAc;IAChB;;IAEA;MACE,qCAAqC;MACrC,SAAS;IACX;;IAEA;MACE,aAAa;IACf;EACF;EACA;IACE;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;MACjB,eAAe;IACjB;;IAEA;MACE,qCAAqC;MACrC,SAAS;IACX;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,UAAU;IACZ;EACF","sourcesContent":[".container {\n    max-width: 95%;\n    margin: 0 auto;\n    padding: 0px;\n    background: #1a1a1a;\n    min-height: 100vh;\n    color: #e0e0e0;\n    padding-top: 5rem;\n  }\n  \n  .header {\n    display: flex;\n    align-items: center;\n    margin-bottom: 25px;\n    position: relative;\n    flex-wrap: wrap;\n    gap: 15px;\n  }\n  \n  .header:after {\n    content: '';\n    position: absolute;\n    bottom: -10px;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    background: #333;\n  }\n  \n  .header h1 {\n    font-size: 24px;\n    font-weight: 600;\n    color: #e0e0e0;\n    margin: 0;\n  }\n  \n  .backButton {\n    background: #e51e1e;\n    border: none;\n    border-radius: 20px;\n    padding: 8px 16px;\n    cursor: pointer;\n    font-size: 14px;\n    color: white;\n    font-weight: 500;\n  }\n  \n  .backButton:hover {\n    background: #e51e1e;\n  }\n  \n  .audioGrid {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    gap: 20px;\n    margin-top: 20px;\n  }\n  \n  .audioCard {\n    border-radius: 5px;\n    overflow: hidden;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n    transition: transform 0.3s ease;\n    cursor: pointer;\n    background: #1e1e1e;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n  \n \n  \n  .audioImageContainer {\n    overflow: hidden;\n    position: relative;\n    height: auto;\n  }\n  \n  .audioImage {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: transform 0.3s ease;\n  }\n  \n  .audioCard:hover .audioImage {\n    transform: scale(1.05);\n  }\n  \n  .categoryBadge {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: rgba(229, 80, 30, 0.8);\n    color: white;\n    padding: 4px 8px;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 500;\n    z-index: 1;\n  }\n  \n  .loadingContainer, .errorContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 50vh;\n  }\n  \n  .error {\n    color: #ef5350;\n    background: #2c2c2c;\n    padding: 15px 20px;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    font-size: 15px;\n    text-align: center;\n  }\n  \n  .noContent {\n    text-align: center;\n    padding: 40px 20px;\n    color: #9e9e9e;\n    font-size: 16px;\n    background: #1e1e1e;\n    border-radius: 8px;\n    margin-top: 20px;\n  }\n  \n  .searchContainer {\n    position: relative;\n    margin-left: auto;\n    width: 240px;\n  }\n  \n  .searchInput {\n    padding: 8px 15px 8px 36px;\n    border-radius: 20px;\n    border: 1px solid #333;\n    font-size: 14px;\n    background: #1e1e1e;\n    color: #e0e0e0;\n  }\n  \n  .searchInput:focus {\n    outline: none;\n    border-color: #e51e1e;\n  }\n  \n  .searchInput::placeholder {\n    color: #9e9e9e;\n  }\n  \n  .searchIcon {\n    position: absolute;\n    top: 50%;\n    left: 12px;\n    transform: translateY(-50%);\n    color: #9e9e9e;\n  }\n  \n  /* Skeleton loading animation */\n  .skeletonCard {\n    border-radius: 8px;\n    overflow: hidden;\n    background: #1e1e1e;\n  }\n  \n  .skeletonImage {\n    height: 200px;\n    background: #2a2a2a;\n    animation: pulse 1.5s infinite alternate;\n  }\n  \n  .skeletonContent {\n    padding: 15px;\n  }\n  \n  .skeletonTitle {\n    height: 16px;\n    width: 90%;\n    background: #2a2a2a;\n    border-radius: 4px;\n    margin-bottom: 8px;\n    animation: pulse 1.5s infinite alternate;\n  }\n  \n  .skeletonAuthor {\n    height: 12px;\n    width: 60%;\n    background: #2a2a2a;\n    border-radius: 4px;\n    animation: pulse 1.5s infinite alternate;\n  }\n  \n  @keyframes pulse {\n    from { opacity: 0.6; }\n    to { opacity: 0.9; }\n  }\n  \n  /* Responsive adjustments */\n  @media (max-width: 768px) {\n    .header {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 10px;\n    }\n    \n    .searchContainer {\n      width: 100%;\n      margin-left: 0;\n    }\n    \n    .audioGrid {\n      grid-template-columns: repeat(4, 1fr);\n      gap: 15px;\n    }\n    \n    .audioImageContainer {\n      height: 200px;\n    }\n  }\n  @media (max-width: 480px) {\n    .header h1 {\n      font-size: 18px;\n    }\n    \n    .backButton {\n      padding: 6px 12px;\n      font-size: 12px;\n    }\n    \n    .audioGrid {\n      grid-template-columns: repeat(3, 1fr);\n      gap: 10px;\n    }\n    \n    .audioImageContainer {\n      height: 180px;\n    }\n    \n    .searchInput {\n      width: 50%;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ReadMoreNonFictionalComponent_container__n7GUh`,
	"header": `ReadMoreNonFictionalComponent_header__5dyuj`,
	"backButton": `ReadMoreNonFictionalComponent_backButton__7fikB`,
	"audioGrid": `ReadMoreNonFictionalComponent_audioGrid__mzoBE`,
	"audioCard": `ReadMoreNonFictionalComponent_audioCard__5NHld`,
	"audioImageContainer": `ReadMoreNonFictionalComponent_audioImageContainer__rtJe1`,
	"audioImage": `ReadMoreNonFictionalComponent_audioImage__xfFr2`,
	"categoryBadge": `ReadMoreNonFictionalComponent_categoryBadge__I93yI`,
	"loadingContainer": `ReadMoreNonFictionalComponent_loadingContainer__3Qeho`,
	"errorContainer": `ReadMoreNonFictionalComponent_errorContainer__N+QeX`,
	"error": `ReadMoreNonFictionalComponent_error__98-7G`,
	"noContent": `ReadMoreNonFictionalComponent_noContent__FTgZV`,
	"searchContainer": `ReadMoreNonFictionalComponent_searchContainer__9Kww5`,
	"searchInput": `ReadMoreNonFictionalComponent_searchInput__wXk65`,
	"searchIcon": `ReadMoreNonFictionalComponent_searchIcon__7uk9A`,
	"skeletonCard": `ReadMoreNonFictionalComponent_skeletonCard__sYBuQ`,
	"skeletonImage": `ReadMoreNonFictionalComponent_skeletonImage__FT-YP`,
	"pulse": `ReadMoreNonFictionalComponent_pulse__skfHe`,
	"skeletonContent": `ReadMoreNonFictionalComponent_skeletonContent__PWENg`,
	"skeletonTitle": `ReadMoreNonFictionalComponent_skeletonTitle__CUbzP`,
	"skeletonAuthor": `ReadMoreNonFictionalComponent_skeletonAuthor__UJwfI`
};
export default ___CSS_LOADER_EXPORT___;
